/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import AlertEventState from '@avtechsoftware/ra-javascript-utilities/src/types/AlertEventState';
import envConfig from '../../../envConfig';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';

const selectActiveAlertEventList = (state) => state.alertEvents.activeAlertEventList;
const selectActiveAlertEventsForAlertId = createSelector([
  selectActiveAlertEventList,
  (eventList, alertId) => alertId],
(activeAlerts, alertId) => activeAlerts
  .filter((activeAlertId) => activeAlertId.alertId === alertId)[0]);

const fetchAlertEvents = createAsyncThunk(
  'alertEvents/fetchAlertEvents',
  async (_, rejectWithValue) => {
    try {
      return await RaaAuthenticatedRemoteService
        .globalInstance()
        .get(`${envConfig.apiUrl}/api/v1/alerts/event/active/find-all`);
    } catch (error) {
      return rejectWithValue({
        name: error.name,
        message: error.message,
        data: error.data,
      });
    }
  },
);

export const alertEventsSlice = createSlice({
  name: 'alertEvents',
  initialState: {
    loading: true,
    error: false,
    activeAlertEventList: [],
  },
  reducers: {
    clearAlertEventsSlice: () => ({
      loading: true,
      error: false,
      activeAlertEventList: [],
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAlertEvents.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchAlertEvents.fulfilled, (state, action) => {
        if (action.payload && action.payload.activeAlertIdList) {
          const { activeAlertIdList } = action.payload;
          state.activeAlertEventList = activeAlertIdList.map((activeAlertEventId) => ({
            alertId: activeAlertEventId,
            alertEventStateId: AlertEventState.ALARMED,
          }));
        }
        state.loading = false;
      })
      .addCase(fetchAlertEvents.rejected, (state) => {
        state.error = true;
      });
  },
});

const { actions, reducer } = alertEventsSlice;
export const { clearAlertEventsSlice } = actions;
export { selectActiveAlertEventList, selectActiveAlertEventsForAlertId, fetchAlertEvents };
export default reducer;
